import axios from "axios";

import {
  CREATED_TRAVELER_PROFILE,
  IPerson,
  TravelerProfileProperties,
  UPDATED_TRAVELER_PROFILE,
} from "redmond";
import {
  getTravelerProfileTrackingProperties,
  isCorpTenant,
  replaceObjectValues,
} from "@capone/common";
import { ToggleActions } from "halifax";

import { passengersApiPrefix } from "../../paths";
import { config } from "../../config";
import { trackEvent } from "../trackEvent";

const END_POINT: string = `${passengersApiPrefix}/update`;

export interface IUpdateUserPassengerResponse {
  person?: IPerson;
}

export interface IUpdateUserPassengerRequest {
  person: IPerson;
  isNewTraveler?: boolean;
  source?: string;
  hideProfileAction?: ToggleActions;
  entryPoint?: string;
  previousPerson?: IPerson;
}

export const updateUserPassenger = (
  body: IUpdateUserPassengerRequest
): Promise<IUpdateUserPassengerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const {
        isNewTraveler,
        hideProfileAction,
        entryPoint,
        person,
        previousPerson,
        ...payload
      } = body;

      const cleanPersonPayload = replaceObjectValues(person, "", null);

      const res = await axios.put(
        END_POINT,
        { ...payload, person: cleanPersonPayload },
        {
          baseURL: config.baseURL,
        }
      );

      const responseBody = res.data;
      resolve(responseBody.person || body.person);

      if (isCorpTenant(config.TENANT)) {
        trackEvent({
          eventName: isNewTraveler
            ? CREATED_TRAVELER_PROFILE
            : UPDATED_TRAVELER_PROFILE,
          properties: {
            ...getTravelerProfileTrackingProperties({
              person: body.person,
              previousPerson,
            }),
            source: body.source,
            private: hideProfileAction === ToggleActions.ON,
            entry_point: entryPoint,
          } satisfies TravelerProfileProperties,
        });
      }
    } catch (e) {
      reject(e);
    }
  });
